





























import { Component, Vue, Prop } from "vue-property-decorator";

interface PinPadItem {
  fabType: boolean,
  className: string,
  isIcon: boolean,
  text: string | undefined,
  action: Function | undefined,
  visibility: Function,
  disabled: Function
}
@Component({
})
export default class LoginWithoutPassword extends Vue {

  @Prop() title!: string;

  @Prop() cancelBtnName!: string;

  get titleValue(): string {
    return this.title || "Введите короткий код";
  }

  get cancelBtnNameValue(): string {
    return this.cancelBtnName || "Выйти";
  }

  pin: string = ""

  progress: any = [];

  pinLength: number = 4;

  progressEmptyArr: Array<number> = [];

  pinPad: Array<Array<PinPadItem>> = [];

  disableNumPad: boolean = false;

  loading: boolean = false;

  constructor() {
    super();
    for (let i: number = 0; i < this.pinLength; i++) {
      this.progressEmptyArr.push(i);
    }

    const stringLength: number = 3;
    for (let i: number = 0; i < stringLength; i++) {
      const pinPadString: Array<PinPadItem> = [];
      for (let k: number = 1; k < stringLength + 1; k++) {
        const num: number = k + i * stringLength;
        pinPadString.push({
          className: "pin-number",
          fabType: true,
          isIcon: false,
          text: num.toString(),
          action: () => { this.clickNumPadNum(num); },
          visibility: () => true,
          disabled: () => this.disableNumPad
        });
      }
      this.pinPad.push(pinPadString);
    }

    const pinPadString: Array<PinPadItem> = [];
    pinPadString.push({
      className: "pin-grey-btn",
      fabType: false,
      isIcon: false,
      text: this.cancelBtnNameValue,
      action: this.cancel,
      visibility: () => true,
      disabled: () => false
    });
    pinPadString.push({
      className: "pin-number",
      fabType: true,
      isIcon: false,
      text: (0).toString(),
      action: () => { this.clickNumPadNum(0); },
      visibility: () => true,
      disabled: () => this.disableNumPad
    });
    pinPadString.push({
      className: "pin-grey-btn",
      fabType: false,
      isIcon: true,
      text: "mdi-backspace",
      action: this.clear,
      visibility: () => !!this.progress.length,
      disabled: () => false
    });
    this.pinPad.push(pinPadString);
  }

  clickNumPadNum = (num: number) => {
    if (this.disableNumPad || this.progress.length == this.pinLength)
      return;
    this.progress.push(num);

    if (this.progress.length == this.pinLength) {
      this.disableNumPad = true;
      this.execute();
    }
  }

  clear = () => {
    this.progress.pop();
    this.disableNumPad = false;
  }

  execute = () => {
    this.pin = "";
    this.progress.forEach((element: number) => {
      this.pin += element.toString();
    });
    this.loading = true;
    for(let i = 0; i< this.pinLength; i++) {
      this.progress.pop();
      this.disableNumPad = false;
    }
    this.$emit("onExecute", this.pin);
    
  }

  cancel = () => {
    this.$emit("onCancel");
  }
}
